var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myapp",on:{"click":() => _vm.isClick(_vm.app)}},[_c('div',{staticClass:"myapp__icon"},[_c('img',{staticClass:"myapp__img",attrs:{"src":_vm.app.icon,"alt":_vm.app.name}})]),_c('p',{staticClass:"myapp__label",attrs:{"ellipsis":""}},[_vm._v(_vm._s(_vm.app.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }